import { render, staticRenderFns } from "./IconLoading.vue?vue&type=template&id=319e7488&"
import script from "./IconLoading.vue?vue&type=script&lang=js&"
export * from "./IconLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports